export default __webpack_public_path__ + "beta-maps-guides-migrate-3d-model-960-a56853d07247b8bd7272d7e88816de0f.png";